exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleSelector {\n    width: 100%;\n}", ""]);

// exports
